import React from 'react';

const BreweryIcon = (props) => {
  return (
    <img
      alt="Browar"
      src="/static/images/icons/tourist_attractions/brewery.svg"
      {...props}
    />
  );
};

export default BreweryIcon;
